<template>
  <div>
    <h3 v-if="title" class="hidden ota-headline text-center mb-2 md:block md:mb-0" v-text="title" />
    <h4 v-if="description" class="hidden ota-body-light text-center mb-12 md:block" v-text="description" />
    <div class="px-5 md:px-0">
      <div class="rounded pt-14 md:pt-0" :style="wrapperStyles">
        <h3 v-if="title" class="ota-title text-white text-center mb-2 px-2 md:hidden" v-text="title" />
        <h4 v-if="description" class="ota-small-light text-white text-center md:hidden" v-text="description" />
        <div class="overflow-x-scroll flex px-5 md:px-0 pt-10 pb-16 md:p-0 md:overflow-x-hidden justify-center">
          <div
            v-for="(membership) in membershipData"
            :key="membership.id"
            class="discover-membership-block mr-8 md:rounded md:mr-5 md:flex-1"
            :class="{ 'hidden': membership.id === orientationId }"
            :style="blockStyles"
          >
            <h5 class="ota-small text-white text-center mb-8 md:ota-headline md:text-white md:mb-1 md:pt-16" v-text="membership.title" />
            <h5 class="hidden text-center mb-10 ota-body-light text-white md:block" v-text="membership.body" />
            <div class="md:flex md:justify-center">
              <div class="discover-membership-image-container bg-white rounded-full relative">
                <!-- TODO Dynamic alt tag (e.g. Model close up men originals, Model close up men one, Model close up boys originals)-->
                <OImage
                  img-class="rounded-full mx-auto"
                  :mobile="membership.images.mobile"
                  :desktop="membership.images.desktop"
                  :src="membership.images.fallback"
                  :alt="$t('Accessibilty.AltTags.PhotoOfMembershipTypeWithName', { name: membership.title })"
                />
                <div class="absolute rounded-full w-full h-full top-0 border-4 border-white" />
              </div>
            </div>
            <div v-if="buttonText" class="text-center pt-8 md:pt-9 md:pb-16">
              <OButton
                variant="ghost"
                @click="$emit('click', membership)"
              >
                {{ buttonText }}
              </OButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OrientationsByGroupIds, GroupIdsByName, Orientations } from '@/enums/products'
import { ScreenBreakpoints } from '@/enums/general'
import { convertSrcSet } from '@/utils/general'
import { vueWindowSizeMixin } from 'vue-window-size'
const OButton = () => import('@/components/OButton')
const OImage = () => import('@/components/OImage')

export default {
  name: 'DiscoverMemberships',
  components: {
    OButton,
    OImage
  },
  mixins: [vueWindowSizeMixin],
  props: {
    orientationId: {
      type: String,
      default: GroupIdsByName[Orientations.menoriginals],
      validator: value => Object.keys(OrientationsByGroupIds).includes(value)
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '68,103,141'
    },
    customImages: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    membershipData () {
      return [...Array(3)].reduce((acc, _, index) => {
        const orientationId = this.$t(`HomePage.MembershipTypes[${index}].value`)

        return {
          [orientationId]: {
            id: orientationId,
            title: this.$t(`HomePage.MembershipTypes[${index}].title`),
            body: this.$t(`HomePage.MembershipTypes[${index}].body`),
            images: this.customImages && this.customImages[orientationId] ? this.customImages[orientationId] : convertSrcSet({
              desktop: {
                '1x': `/img/lookbook/fury-${OrientationsByGroupIds[orientationId]}-studio.webp`,
                '2x': `/img/lookbook/fury-${OrientationsByGroupIds[orientationId]}-studio@2x.webp`
              },
              mobile: {
                '1x': `/img/lookbook/fury-${OrientationsByGroupIds[orientationId]}-studio-mob.webp`,
                '2x': `/img/lookbook/fury-${OrientationsByGroupIds[orientationId]}-studio-mob@2x.webp`
              }
            })
          },
          ...acc
        }
      }, {})
    },
    isMediumScreen () {
      return this.windowWidth >= ScreenBreakpoints.md
    },
    wrapperStyles () {
      return {
        'background-color': this.isMediumScreen ? 'transparent' : `rgb(${this.color})`
      }
    },
    blockStyles () {
      return {
        'background-color': this.isMediumScreen ? `rgb(${this.color})` : 'transparent'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.overflow-x-scroll {
  scroll-snap-type: x mandatory;
}

.discover-membership-block {
  scroll-snap-align: center;

  &:nth-child(3) {
    @apply mr-0 !important;
  }
}

.oimage >>> img {
  max-width: 100% !important;
  max-height: 100% !important;
}

.discover-membership-image-container {
  max-width: 18.9rem;
  max-height: 18.9rem;
}

.obutton {
  @apply text-white border-white;
}

@screen md {
  .discover-membership-block {
    &:nth-child(3) {
      @apply mr-0 !important;
    }
  }

  .discover-membership-image-container {
    max-width: 25.9rem;
    max-height: 25.9rem;
  }
}
</style>
